/**
 * Check if the current environment is development or preview.
 * @returns True if the current environment is development or preview, false otherwise.
 * @note Relies on the VERCEL_TARGET_ENV environment variable, https://vercel.com/docs/environment-variables/system-environment-variables#VERCEL_TARGET_ENV
 */
function isDevOrPreview() {
  const targetEnv = process.env.VERCEL_TARGET_ENV;
  const isDevOrPreview = !targetEnv
    ? // If `targetEnv` is not set, check the node environment. This is used to support enabling
      // wrapped features in local environments where `VERCEL_TARGET_ENV` is not set.
      process.env.NODE_ENV === "development"
    : ["development", "preview"].includes(targetEnv);

  return isDevOrPreview;
}

export default isDevOrPreview;
